import { makeAutoObservable, runInAction } from 'mobx'

const SORT_OV_AND_HIDE_ZERO = 'SortOVandHideZero'
const SORT_BY_OV = 'SortOV'
const HIDE_ZERO = 'HideZero'
const NO_SORT = 'noSort'
const GENEALOGY_HISTORY_KEY = 'genealogy_downline_history'

class storeGenealogyFilter {
    hideInactiveLegs = false
    sortByOv = false

    showAll = true
    showDistributor = false
    showMember = false

    showFilterModal = false
    showHistoryModal = false
    shouldRefetch = false
    shouldRefresh = false
    isDirty = false

    history = []

    setShowFilterModal(value) {
        runInAction(() => {
            this.showFilterModal = value
        })
    }

    getShowFilterModal() {
        return this.showFilterModal
    }

    setShowHistoryModal(value) {
        runInAction(() => {
            this.showHistoryModal = value
        })
    }

    getShowHistoryModal() {
        return this.showHistoryModal
    }

    openHistoryModal() {
        runInAction(() => {
            this.showFilterModal = false
            this.showHistoryModal = true
        })
    }

    setShouldRefetch(value) {
        runInAction(() => {
            this.shouldRefetch = value
        })
    }

    getShouldRefetch() {
        return this.shouldRefetch
    }

    setShouldRefresh(value) {
        runInAction(() => {
            this.shouldRefresh = value
        })
    }

    getShouldRefresh() {
        return this.shouldRefresh
    }

    setDirty(value = true) {
        runInAction(() => {
            this.isDirty = value
        })
    }

    getIsDirty() {
        return this.isDirty
    }

    resetDirty() {
        runInAction(() => {
            this.isDirty = false
        })
    }

    closeAndRefetch() {
        runInAction(() => {
            this.showFilterModal = false
            if (this.isDirty) {
                this.shouldRefetch = true
            }
        })
    }

    triggerRefresh() {
        runInAction(() => {
            this.showFilterModal = false
            this.shouldRefresh = true
        })
    }

    setFilterOptions(filterOptions) {
        if (filterOptions.showAll) {
            runInAction(() => {
                this.showAll = filterOptions.showAll
                this.showDistributor = false
                this.showMember = false
                this.isDirty = true
            })
        }
        if (filterOptions.showDistributor) {
            runInAction(() => {
                this.showDistributor = filterOptions.showDistributor
                this.showAll = false
                this.showMember = false
                this.isDirty = true
            })
        }
        if (filterOptions.showMember) {
            runInAction(() => {
                this.showMember = filterOptions.showMember
                this.showAll = false
                this.showDistributor = false
                this.isDirty = true
            })
        }
    }

    getFilterOptions(filterKey) {
        if (filterKey === 'showAll') {
            return this.showAll
        }
        if (filterKey === 'showDistributor') {
            return this.showDistributor
        }
        if (filterKey === 'showMember') {
            return this.showMember
        }
    }

    getFilterOptionsString() {
        if (this.hideInactiveLegs && this.sortByOv) {
            return SORT_OV_AND_HIDE_ZERO
        } else if (this.sortByOv) {
            return SORT_BY_OV
        } else if (this.hideInactiveLegs) {
            return HIDE_ZERO
        } else {
            return NO_SORT
        }
    }

    // History management for downline navigation
    addToHistory(item) {
        const history = this.getHistory()
        // Avoid duplicates - remove if exists and add to end
        const filteredHistory = history.filter(h => h.customerId !== item.customerId)
        filteredHistory.push({
            ...item,
            timestamp: new Date().toISOString()
        })
        // Keep only last 50 items
        const trimmedHistory = filteredHistory.slice(-50)
        sessionStorage.setItem(GENEALOGY_HISTORY_KEY, JSON.stringify(trimmedHistory))
        runInAction(() => {
            this.history = trimmedHistory
        })
    }

    getHistory() {
        return this.history
    }

    clearHistory() {
        sessionStorage.removeItem(GENEALOGY_HISTORY_KEY)
    }

    removeFromHistory(customerId) {
        const history = this.getHistory()
        const filteredHistory = history.filter(h => h.customerId !== customerId)
        sessionStorage.setItem(GENEALOGY_HISTORY_KEY, JSON.stringify(filteredHistory))
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const StoreGenealogyFilter = new storeGenealogyFilter()
export default StoreGenealogyFilter
